/**
 * - De inhoud van deze file een map hoger zetten. (swup.settings.js bijv)
 * - studentenkorting.js ontleden en opdelen in meerdere kleine files.
 * - onderzoeken javascript files in de bundel nodig zijn
 * - en welke lazy geladen kunnen worden
 *
 */


var times = 0;
var isBackButton = false;

function shop_init() {
    if(typeof gtag != 'undefined' && gtag != null) {
        gtag('event', 'page_view', {
            page_location: document.location.pathname,
            page_path: document.location.pathname
            // send_to: '<GA_MEASUREMENT_ID>'
        })
    }
    map = null;
    bounds = null;
    markers = [];
    infohover = null;

    // $(document).scrollTop(0);
    times++;
}

function loadMyPage(url) {
    return navigateTo(url);
}

function shopGetProductUrl(url) {
    $.get(url, function(data) {
        navigateTo(data.url);
    }, 'json');
}
function navigateTo(url) {
    console.log('navigateTo: ' + url);
    swup.loadPage({
        url: url, // route of request (defaults to current url)
        method: 'GET', // method of request (defaults to "GET")
        // data: data, // data passed into XMLHttpRequest send method
        // customTransition: '' // name of your transition used for adding custom class to html element and choosing custom animation in swupjs (as setting data-swup-transition attribute on link)
    });
}

var historyLength = history.length;
function navigateToPrevious(e) {
    if(times > 1) {
        e.preventDefault();
        history.go(-1);
    }
}

function navigateToShop(url) {
    console.log('navigateToShop: ' + url);
    swup.loadPage({
        url: url, // route of request (defaults to current url)
        method: 'GET', // method of request (defaults to "GET")
        // data: data, // data passed into XMLHttpRequest send method
        customTransition: 'trans-shop' // name of your transition used for adding custom class to html element and choosing custom animation in swupjs (as setting data-swup-transition attribute on link)
    });

}


const swup = new Swup({
    // plugins: [new SwupFadeTheme({
    //     mainElement: "#swup"
    // })],
    // containers: ["#swup", "#swup-nav", "#swup-nav2", "#navbar", "#swup-header"]
    containers: ["#wrapper"],
    // linkSelector: 'a[href^="' + window.location.origin + '"]:not([data-no-swup]), a[href^="/"]:not([data-no-swup]), a[href^="#"]:not([data-no-swup], a[href^="?"]:not([data-no-swup])'
    linkSelector: 'a[href^="' + window.location.origin + '"]:not([data-no-swup]), a[href^="?"]:not([data-no-swup]), a[href^="/"]:not([data-no-swup]), a[href^="#"]:not([data-no-swup])'
}); // only this line when included with script tag

shop_init();

var swup_load_to = null;
var swup_scrolled_to_top = false;



swup.on('contentReplaced', shop_init)
swup.on('animationOutDone', function() {

    $('html').addClass('noscrollanimation');

    setTimeout(function() {
        if(!$('html').is('.to-trans-shop')) {
            swup_scrolled_to_top = true;
            window.scroll(0, 0);
        }
        else {
            swup_scrolled_to_top = false;
        }
        //
        $('html').removeClass('noscrollanimation');
    }, 50);

    swup_load_to = setTimeout(function() {
        // $('body').addClass('loading-swup');
    }, 1000)


});

swup.on('willReplaceContent', function(popstate) {

});
swup.on('animationOutStart', function() {
    $('body').addClass('beforeunload');
    $('body').removeClass('onload');
});

swup.on('contentReplaced', function() {
    $('body').addClass('onload');
    $('body').removeClass('beforeunload');
})

swup.on('animationInStart', function() {
    if(swup_load_to) clearTimeout(swup_load_to);
    $('body').removeClass('loading-swup');
    if(!swup_scrolled_to_top) {
        window.scroll(0,0);
    }
});

function AddPageSwapTrigger(func) {
    $(document).ready(func);
    swup.on('contentReplaced', func);

}

function AddPageSwapTriggerSwup(func) {
    swup.on('contentReplaced', func);
}

function AddPageSwapTriggerLazy(func) {
    swup.on('contentReplaced', func);
    func();
}

function LoadLazyScript(name) {
    // Make sure script is only loaded once.
    if(loadedScripts.includes(name)) return;
    loadedScripts[loadedScripts.length] = name;

    var version = $('body').data('version');
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = "https://" + window.location.host.replace('www.','cdn.') + "/dist/" + name + ".bundle.js?v=" + version;
    script.defer = true;
    head.appendChild(script);
}

var currentHash = {};
var old_height = 0;
var loader_salt = 0;

var lastUrl = "";
var lastRequest = null;

var lazy_ready = false;
var maps_ready = false;

var lazy = {
    timer: 10000,
    toLazy: null,
    toMaps: null,
    init: function() {
        // lazy.toLazy = setTimeout(lazy.loadLazy, lazy.timer, 5000);
        // lazy.toMaps = setTimeout(lazy.loadMaps, lazy.timer, 10000);
    },
    loadLazy: function() {
        if(lazy.toLazy) clearTimeout(lazy.toLazy);

        var version = $('body').data('version');
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.onload = function() {
            lazy_ready = true;
        };
        script.src = "https://" + window.location.host.replace('www.','cdn.') + "/dist/lazy.bundle.js?v=" + version;
		//script.async = true;
		script.defer = true;
        head.appendChild(script);

    },
    loadMaps: function() {
        if(lazy.toMaps) clearTimeout(lazy.toMaps);
        if(lazy.toLazy) clearTimeout(lazy.toLazy);

        var version = $('body').data('version');
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.onload = function() {
            maps_ready = true;
            // lazy.loadLazy();
            if($('#maps').is('.active')) {
                $('#maps').click();
            }
        };
        script.src = "https://maps.google.com/maps/api/js?sensor=false&key=" + sk_maps_key;
		//script.async = true;
		script.defer = true;
        head.appendChild(script);


    }
}

jQuery(document).ready(function($) {
    lazy.init();
});


AddPageSwapTrigger(function() {
    if($('.panel .mcheck').is('.mcheck') || $('.set-favorite').is('.set-favorite') || $('.filterletter').is('.filterletter')) {
        LoadLazyScript('filter');
    }
    if($('.map-canvas').is('.map-canvas') || $('.map-streetview').is('.map-streetview')) {
        LoadLazyScript('maps');
        if(typeof google == 'undefined' || typeof google.maps == 'undefined') {
            lazy.loadMaps();
        }

    }
    if(
        $('form#frmnieuwsbrief').is('form#frmnieuwsbrief') ||
        $('form#contact_frm').is('form#contact_frm') ||
        $('.recaptcha-form').is('.recaptcha-form')
        ) {
        LoadLazyScript('form');
    }
});


// v product navigatie
// formulieren
// maps
// v google analytics plugin and cookies consent
// nationaal coupon click mobiel

// v overzichtpagina's
//      - toon gratis en exclusieve kortingen
// v merkenpagina's
// V zoeken
// v product detailpagina's
// V goto pagina's
